<template>
  <div class="szw-floating-chat" style="font-family: 'Plus Jakarta Sans', Inter, sans-serif;">
    <!-- Chat panel -->
    <Transition name="szw-chat-pop">
      <div v-if="open" class="szw-floating-chat__panel">
        <FacilityFinderChat ref="chat" @close="open = false"/>
      </div>
    </Transition>

    <!-- Floating action button -->
    <button
      class="szw-floating-chat__fab"
      :aria-label="$t('samergo_home_chat_start')"
      @click="toggle"
    >
      <span class="material-symbols-outlined szw-floating-chat__fab-icon">{{ open ? 'close' : 'support_agent' }}</span>
    </button>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import FacilityFinderChat from '@/Domain/ConversationalAgent/Components/FacilityFinderChat.vue'

  export default defineComponent({
    name: 'SamergoFloatingChat',
    components: { FacilityFinderChat },
    data() {
      return {
        open: false,
      }
    },
    methods: {
      async toggle() {
        this.open = !this.open
        if (this.open) {
          await this.$nextTick()
          ;(this.$refs.chat as any)?.focusInput?.()
        }
      },
    },
  })
</script>

<style scoped>
  .szw-floating-chat {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 12px;
  }

  .szw-floating-chat__panel {
    width: min(380px, calc(100vw - 32px));
    transform-origin: bottom right;
  }

  .szw-floating-chat__fab {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #071c5b;
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(7, 28, 91, 0.35);
    align-self: flex-end;
    transition: transform 0.15s ease;
  }

  .szw-floating-chat__fab:hover {
    transform: scale(1.05);
  }

  .szw-floating-chat__fab:active {
    transform: scale(0.95);
  }

  .szw-floating-chat__fab-icon {
    font-size: 28px;
  }

  /* Pop animation */
  .szw-chat-pop-enter-active,
  .szw-chat-pop-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .szw-chat-pop-enter-from,
  .szw-chat-pop-leave-to {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
</style>
